/**
 * The Strategy Tester's address. It sits under the strategy list it is opened from, so the left nav marks Strategies
 * while it is open (the nav marks the longest matching entry: under `/finance` it marked the Trading Dashboard).
 */
export const TESTER_PATH = '/finance/strategies/tester';
/** Its address until 2026-10-19, redirected to `TESTER_PATH` with its query (`routes.tsx`). */
export const LEGACY_TESTER_PATH = '/finance/tester';

/** The Strategy Tester on one strategy (it opens its latest run); the strategy list links every row here. */
export function testerPath(definitionId: string, runId?: string): string {
  const params = new URLSearchParams({ def: definitionId });
  if (runId) params.set('run', runId);
  return `${TESTER_PATH}?${params.toString()}`;
}
